<rav-modal modalId="plan-selection" revealSize="small" data-cy="plan-selection">
  <h2>Choose Your Plan</h2>
  <div class="grid-x grid-margin-x text-center">
    <div *ngFor="let plan of plans; index as i; odd as isOdd; even as isEven" class="large-6 cell">
      <div class="small callout" [class.primary]="isOdd" [class.secondary]="isEven">
        <div class="grid-x align-center align-middle margin-bottom-1">
          <div class="shrink cell margin-right-1">
            <img
              [src]="plan.fields.image.fields.file.url"
              [alt]="plan.fields.image.fields.title"
              class="plan-selection__logo"
            />
          </div>
          <div class="shrink cell">
            <h3 class="pricing-table__plan margin-0">{{ plan.fields.planName }}</h3>
          </div>
        </div>
        <div class="grid-x grid-padding-x align-center">
          <div *ngIf="canSelectMonthly()" class="medium-6 cell">
            <strong *ngIf="isCurrentPlan(plan.fields.stripePlanName + '.' + 'monthly')">Current Plan</strong>
            <label>
              <input
                *ngIf="!isCurrentPlan(plan.fields.stripePlanName + '.' + 'monthly')"
                [(ngModel)]="selectedPlan"
                type="radio"
                name="plan"
                [value]="plan.fields.stripePlanName + '.' + 'monthly'"
                class="margin-bottom-0"
              />
              {{ plan.name }}
              <span>Billed Monthly</span>
              <div class="pricing-table__price">{{ plan.fields.monthlyPrice | currency }}/mo</div>
            </label>
          </div>
          <div class="medium-6 cell">
            <strong *ngIf="isCurrentPlan(plan.fields.stripePlanName + '.' + 'annually')">Current Plan</strong>
            <label>
              <input
                *ngIf="!isCurrentPlan(plan.fields.stripePlanName + '.' + 'annually')"
                [(ngModel)]="selectedPlan"
                type="radio"
                name="plan"
                [value]="plan.fields.stripePlanName + '.' + 'annually'"
                class="margin-bottom-0"
              />
              <span>Billed Annually</span>
              <div class="pricing-table__price">{{ plan.fields.yearlyPrice / 12 | currency }}/mo</div>
              <em>({{ plan.fields.yearlyPrice | currency }})</em>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-x">
    <div class="shrink cells">
      <div class="small callout text-left padding-horizontal-1">
        <strong>Your Payment Method</strong>
        <rav-payment-method [account]="account"></rav-payment-method>
      </div>
    </div>
  </div>

  <button
    (click)="modal.close.next({ selectedPlan: selectedPlan })"
    type="button"
    class="button margin-right-1 margin-bottom-0"
  >
    Start Plan
  </button>
  <button (click)="modal.close.next()" type="button" class="hollow button margin-bottom-0">Cancel</button>
</rav-modal>
